// extracted by mini-css-extract-plugin
export default {"wrapper":"AdvtSms_wrapper__sTG5J","title":"AdvtSms_title__rAszW","subtitle":"AdvtSms_subtitle__Wd5lv","phoneNumber":"AdvtSms_phoneNumber__BMJBu"};